const CatcherTheme = {
  
}

export default CatcherTheme